<template>
  <b-card
    v-if="countByApplyDocResearcherRegion"
    no-body
  >
    <div v-if="!region">
      <b-card-header>
        <b-card-title>{{ $t('Number of doctoral students and research advisors in the region') }}</b-card-title>
      </b-card-header>
      <!-- chart -->
      <b-table
        :items="countByApplyDocResearcherRegion"
        responsive
        :fields="fields"
        class="mb-0"
        :per-page="perPage"
        :current-page="currentPage"
      >
        <template #head()="data">
          {{ $t(data.label) }}
        </template>

        <template #cell(index)="data">
          {{ (currentPage - 1) * perPage + data.index + 1 }}
        </template>

        <template #cell(name)="data">
          {{ $langName(data.value) }}
        </template>

        <template #cell(actions)="data">
          <feather-icon
            icon="EyeIcon"
            class="cursor-pointer mr-1"
            size="16"
            @click="selectRegion(data.item)"
          />
        </template>

      </b-table>
      <div class="mb-1 mr-1">
        <b-row>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="12"
            class="d-flex align-items-end justify-content-end justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="total"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>
        </b-row>
      </div>
    </div>
    <div v-else>
      <count-by-apply-doc-researcher-region-org-component
        :region="region"
        @clearRegion="clearRegion"
      />
    </div>
  </b-card>
</template>
<script>
import {
  BCard, BCardHeader, BCardTitle, BTable, BPagination, BRow, BCol,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import CountByApplyDocResearcherRegionOrgComponent from './CountByApplyDocResearcherRegionOrgComponent.vue'

export default {
  name: 'OrgCountByTypeAndOrgAdminComponent',
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BTable,
    BPagination,
    BRow,
    BCol,
    CountByApplyDocResearcherRegionOrgComponent,
  },
  data() {
    return {
      region: null,
    }
  },
  computed: {
    countByApplyDocResearcherRegion() {
      return this.$store.state[this.MODULE_NAME].countByApplyDocResearcherRegion
    },
  },
  created() {
    this.$store.dispatch(`${this.MODULE_NAME}/countByApplyDocResearcherRegion`).then(res => {
      this.total = res.data.length
    })
  },
  methods: {
    selectRegion(region) {
      this.region = region
    },
    clearRegion() {
      this.region = null
    },
  },
  setup() {
    const fields = [
      { key: 'index', label: '#' },
      { key: 'name', label: 'Region', thClass: 'h6' },
      { key: 'researcher_itm_count', label: 'Research advisor count in ITM', thClass: 'h6' },
      { key: 'researcher_otm_count', label: 'Research advisor count in OTM', thClass: 'h6' },
      { key: 'apply_doc_itm_count', label: 'Doctoral student count in ITM', thClass: 'h6' },
      { key: 'apply_doc_otm_count', label: 'Doctoral student count in OTM', thClass: 'h6' },
      { key: 'actions', label: 'Actions', thClass: 'h6' },
    ]
    const perPage = ref(5)
    const total = ref(0)
    const currentPage = ref(1)
    const MODULE_NAME = 'statistic'
    return {
      MODULE_NAME,
      fields,
      perPage,
      total,
      currentPage,
    }
  },
}
</script>

<style scoped>

</style>
